import { PRODUCT_ANALYTICS_POPULATE } from "../../constants/types";
import axios from "axios";
  
  
  export const requestProductAnalyticsData = () => {
    return (dispatch, getState)=>{
      return new Promise((resolve, reject) => {
        const { filters } = getState().analytics;
        const locations = getState().selectedLocations;
        axios
          .get("api/products/", {
            params: {
              locations,
              end_date: filters.selectedDate.end_date,
              type: "oscar_dashboard"
            }
          })
          .then(response => {
            dispatch({
              type: PRODUCT_ANALYTICS_POPULATE,
              payload: response.data
            });
          });
      });
    
    }
  };
  
  


// WEBPACK FOOTER //
// ./src/modules/productAnalytics/ProductAnalyticsActions.js